import {toast} from "react-hot-toast";
import {FaCircle, FaLink} from "react-icons/fa6";

import {DropdownItem} from "@/components/dropdown/subComponents/DropdownItem/DropdownItem.tsx";
import {DropdownButton} from "@/components/dropdownButton/DropdownButton.tsx";
import {useCopyToClipboard} from "@/lib/hooks/useCopyToClipboard.ts";

interface ShareReportProps {
  url: string;
  className?: string;
  btnText?: string;
}

export const ShareReport = ({url, btnText}: ShareReportProps) => {
  const [, copy] = useCopyToClipboard();
  return (
    <DropdownButton
      id="share-report-btn"
      variant={"secondary"}
      size={"large"}
      icon={FaLink}
      title={btnText ?? "Share Check Analysis"}
      aria-haspopup="true"
      menuProps={{
        className: "p-3 last-child-no-margin",
        ["aria-labelledby"]: "share-report-btn",
        style: {minWidth: "20rem"},
      }}
    >
      <h5 className="fw-bold">{btnText ?? "Share Check Analysis"}</h5>
      <p>Anyone with the link can view a read only version of this Check Analysis.</p>
      <DropdownItem
        className="d-flex align-items-center cursor-pointer border-0 bg-transparent"
        onClick={async () => {
          await copy(url);
          toast.success("Text successfully copied to clipboard.");
        }}
      >
        <span className="d-grid me-2">
          <FaCircle className="text-subtle" size="2rem" style={{gridArea: "1/1"}} />
          <FaLink className="fw-semibold text-success-brand p-1" size="2rem" style={{gridArea: "1/1"}} />
        </span>
        <span className="text-decoration-underline text-success-brand fs-7">Copy Link</span>
      </DropdownItem>
    </DropdownButton>
  );
};
